<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="categorie_nouvelle"
      v-model="sasInscriptionTableau.categorieDeMembre"
      :live="liveSasInscriptionTableau(7703)"
      :filter="(fd) => filterCatalogueCategorie(fd)"
      @eudo-updated="categorieChanged"
    ></CatalogueLive>

    <CaseACocherLive
      v-if="estRetraite(sasInscriptionTableau.categorieDeMembre)"
      code="engagement_retraite"
      v-model="sas.sasInscriptionTableau.engagementRetraite"
      :live="liveSasInscriptionTableau(7707)"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import { mapActions } from "vuex"
import { eventBus } from "@/plugins/eventBus"

export default {
  mixins: [CataloguesHelpers, DatesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    },
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: "demande-renouvellement", sasId: this.sas.id })
    },
    categorieChanged() {
      this.updatePanier()
      eventBus.$emit("categorieChanged")
    },
    liveSasInscriptionTableau(cle) {
      return { endpoint: "sas-inscription-tableau", cle: cle, fileId: this.sasInscriptionTableau.id }
    },
    estInvalidite() {
      return this.getCatalogueCodeById("11136", this.sasInscriptionTableau.categorieDeMembre) == "inv"
    },
    estRetraite() {
      return this.getCatalogueCodeById("11136", this.sasInscriptionTableau.categorieDeMembre) == "retraite"
    },
    filterCatalogueCategorie(fd) {
      if (fd.code == "inv" && !this.identification.estInvaliditePermanenteConfirmee) {
        return false
      }

      if (fd.code == "retraite" && (!(this.identification.age >= 60) || this.identification.estProprietaire || this.identification.estActionnaire)) {
        return false
      }

      return true
    }
  }
}
</script>

<style></style>
